export const storeProducts = [
    {
        id: 1,
        trending: true,
        category: "TV",
        make: "Samsung",
        title: "Samsung Q60R",
        image: "../pImg/TVs Category.jpg",
        disc: "Samsung Q60R Flat 55\" QLED 4K Q60 Series (2019) Ultra HD Smart TV with HDR and Alexa Compatibility",
        price: 749.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 2,
        trending: true,
        category: "Laptop",
        make: "Apple",
        title: "MacBook Air",
        image: "../pImg/Laptop category.png",
        disc: "Apple\'s thinnest, lightest notebook. This much power has never been this ready to go.",
        price: 999.00,
        inCart: false,
        count: 0,
        total: 0
    },

    {
        id: 3,
        trending: true,
        category: "Console",
        make: "Sony",
        title: "Play Station 5",
        image: "../pImg/Console Category.png",
        disc: "(Out Of Stock)",
        price: 399.00,
        inCart: false,
        count: 0,
        total: 0
    },   
    {
        id: 4,
        trending: true,
        category: "Accessories",
        make: "Bose",
        title: "Bose Sport",
        image: "../pImg/Bose Sport.jpg",
        disc: "These Earbuds are designed from the ground up to energize your exercise.",
        price: 179.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 5,
        trending: true,
        category: "Accessories",
        make: "Apple",
        title:"AirPods",
        image: "../pImg/AirPods.jpg",
        disc: "Now with more talk time and a wireless charging case.",
        price: 129.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 6,
        trending: true,
        category: "Accessories",
        make: "Apple",
        title: "AirPod Pros",
        image: "../pImg/AirPods Pro.jpg",
        disc: "AirPods Pro have been designed to deliver ANC for immersive sound.",
        price: 249.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 7,
        category: "TV",
        make: "Samsung",
        title: "Samsung Q70R",
        image: "../pImg/Q70R.jpg",
        disc: "Samsung Q70R Flat 55\" QLED 4K Q70 Series (2019) Ultra HD Smart TV with HDR and Alexa Compatibility",
        price: 849.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 8,
        category: "TV",
        make: "Samsung",
        title: "Samsung Q80R",
        image: "../pImg/Q80R.jpeg",
        disc: "Samsung Q80R Flat 55\" QLED 4K Q80 Series (2019) Ultra HD Smart TV with HDR and Alexa Compatibility",
        price: 949.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 9,
        category: "TV",
        make: "Sony",
        title: "Sony X70H",
        image: "../pImg/Sony X70H.jpg",
        disc: "Sony X70H 55\" 4K Ultra HD TV. See incredible 4K pictures, rich with real-world detail and texture, powered by our 4K Processor X1",
        price: 549.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 10,
        category: "Laptop",
        make: "Asus",
        title: "ROG Zephyrus S15",
        image: "../pImg/ROG Zephyrus S15.jpg",
        disc: "GeForce® RTX 2080 SUPER™ Windows 10 Pro/Home Intel® Core™ i7-10875H 300Hz/3ms",
        price: 2299.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 11,
        category: "Laptop",
        make: "Apple",
        title: "MacBook Pro 16\"",
        image: "../pImg/MacBook Pro 16.jpg",
        disc: "Designed for those who defy limits and change the world, the 16-inch MacBook Pro is by far the most powerful notebook.",
        price: 2399.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 12,
        category: "Laptop",
        make: "Apple",
        title: "MacBook Pro 13\"",
        image: "../pImg/MacBook Pro 13.jpeg",
        disc: "Designed for those who defy limits and change the world, the 16-inch MacBook Pro is by far the most powerful notebook.",
        price: 1299.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 13,
        category: "Tablets",
        make: "Apple",
        title: "iPad Pro 12.9\"",
        image: "../pImg/iPad Pro.jpg",
        disc: "12.9-inch edge-to-edge Liquid Retina display with ProMotion, True Tone, and P3 wide color.",
        price: 999.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 14,
        category: "Tablets",
        make: "Apple",
        title: "iPad Air 10.9\"",
        image: "../pImg/iPad Air.jpg",
        disc: "10.9-inch edge-to-edge Liquid Retina display with ProMotion, True Tone, and P3 wide color.",
        price: 599.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 15,
        category: "Tablets",
        make: "Samsung",
        title: "Galaxy Tab S7",
        image: "../pImg/Tab S7.jpg",
        disc: "12.4-inch Galaxy Tab S7. TABLET PORTABILITY: Transform your tablet into a PC experience.",
        price: 749.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 16,
        category: "Phone",
        make: "Apple",
        title: "iPhone 12 Pro",
        image: "../pImg/iphone 12 pro.jpeg",
        disc: "5G Speed, A14 Bionic, the fastest chip in a smartphone.",
        price: 999.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 17,
        category: "Phone",
        make: "Apple",
        title: "iPhone 12",
        image: "../pImg/iphone 12.jpeg",
        disc: "5G Speed, A14 Bionic, the fastest chip in a smartphone.",
        price:799.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 18,
        category: "Phone",
        make: "Google",
        title: "Google Pixel 5",
        image: "../pImg/Google Pixel.jpg",
        disc: "New, unlocked Android phone gives you the flexibility to change carriers and choose your own data plan.",
        price: 699.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 19,
        category: "Phone",
        make: "Samsung",
        title: "Galaxy S20",
        image: "../pImg/Galaxy S20.jpg",
        disc: "The new Samsung Galaxy S20 FE mobile phone features high-powered pro lenses for beautiful portraits.",
        price: 699.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 20,
        category: "Console",
        make: "Sony",
        title: "PlayStation 4 Pro",
        image: "../pImg/PS4 Pro.jpg",
        disc: "Heighten your experiences. Enrich your adventures. Let the super charged PS4 Pro lead the way.",
        price: 390.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 21,
        category: "Console",
        make: "Sony",
        title: "PlayStation 4 Slim",
        image: "../pImg/PS4 Slim.jpg",
        disc: "Incredible games, endless entertainment. All new lighter slimmer PS4.",
        price: 350.00,
        inCart: false,
        count: 0,
        total: 0
    },

];

export const detailProduct = {
    id: 1,
    category: "Accessories",
    make: "Apple",
    image: "pImg/AirPods Pro.jpg",
    disc: "Apple AirPod Pros Completly Wireless Earbuds",
    price: "$200"
}